import {
  DefaultPage,
  MailTemplate,
  SmsTemplate,
  MailTemplateEdit,
  SmsTemplateEdit,
  TooltipTemplate,
  TooltipTemplateEdit,
  AgreementTemplate,
  AgreementTemplateEdit,
  TypesenseSearchTemplate,
  TypesenseSearchTemplateEdit,
  SocketIOTemplate,
  SocketIOTemplateEdit,
} from './';
export default {
  path: 'template/:version/v',
  name: 'Template',
  childRoutes: [
    { path: ':projectId', name: 'Default page', component: DefaultPage, isPrivate: true },
    {
      path: ':projectId/mails/create',
      name: 'Mail template',
      component: MailTemplate,
      isPrivate: true,
    },
    {
      path: ':projectId/messages/create',
      name: 'Sms template',
      component: SmsTemplate,
      isPrivate: true,
    },
    {
      path: ':projectId/tooltips/create',
      name: 'Tooltip Template',
      component: TooltipTemplate,
      isPrivate: true,
    },
    {
      path: ':projectId/mails/:templateId',
      name: 'Mail template edit',
      component: MailTemplateEdit,
      isPrivate: true,
    },
    {
      path: ':projectId/messages/:templateId',
      name: 'Sms template edit',
      component: SmsTemplateEdit,
      isPrivate: true,
    },
    {
      path: ':projectId/tooltips/:templateId',
      name: 'Tooltip template edit',
      component: TooltipTemplateEdit,
      isPrivate: true,
    },
    {
      path: ':projectId/agreements/create',
      name: 'Agreement template',
      component: AgreementTemplate,
      isPrivate: true,
    },
    {
      path: ':projectId/agreements/:templateId',
      name: 'Agreement template edit',
      component: AgreementTemplateEdit,
      isPrivate: true,
    },
    {
      path: ':projectId/typesenseSearch/create',
      name: 'Typesense Search template',
      component: TypesenseSearchTemplate,
      isPrivate: true,
    },
    {
      path: ':projectId/typesenseSearch/:templateId',
      name: 'Typesense Search template edit',
      component: TypesenseSearchTemplateEdit,
      isPrivate: true,
    },
    {
      path: ':projectId/socketIo/create',
      name: 'Socket IO template',
      component: SocketIOTemplate,
      isPrivate: true,
    },
    {
      path: ':projectId/socketIo/:templateId',
      name: 'Socket IO template edit',
      component: SocketIOTemplateEdit,
      isPrivate: true,
    },
  ],
};
